import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const RatingPopup = ({ isOpen, onSubmit, onClose }) => {
  const [selected, setSelected] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (score) => {
    setSelected(score);
    setSubmitted(true);
    onSubmit(score);
    // Auto-close after brief moment
    setTimeout(onClose, 600);
  };

  // Reset when opened
  React.useEffect(() => {
    if (isOpen) {
      setSelected(null);
      setSubmitted(false);
    }
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -10, scale: 0.95 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          className="flex flex-col items-center"
          data-testid="rating-popup"
        >
          {!submitted ? (
            <>
              <p
                className="text-charcoal/50 text-sm mb-4"
                style={{ fontFamily: "'Caveat', cursive", fontSize: '1.15rem' }}
              >
                How was that conversation?
              </p>
              <div className="flex gap-1.5">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                  <motion.button
                    key={n}
                    whileHover={{ scale: 1.15, y: -2 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={() => handleSubmit(n)}
                    className="w-9 h-9 rounded-full text-sm font-medium transition-colors duration-200 border"
                    style={{
                      borderColor: 'rgba(255, 120, 10, 0.15)',
                      color: '#2C2417',
                      background: 'rgba(255, 252, 248, 0.9)',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#ff780a';
                      e.currentTarget.style.color = '#fff';
                      e.currentTarget.style.borderColor = '#ff780a';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(255, 252, 248, 0.9)';
                      e.currentTarget.style.color = '#2C2417';
                      e.currentTarget.style.borderColor = 'rgba(255, 120, 10, 0.15)';
                    }}
                    data-testid={`rating-${n}`}
                  >
                    {n}
                  </motion.button>
                ))}
              </div>
              <div className="flex justify-between w-full mt-2 px-1">
                <span className="text-charcoal/30 text-xs">Not great</span>
                <span className="text-charcoal/30 text-xs">Amazing</span>
              </div>
              <button
                onClick={onClose}
                className="mt-3 text-charcoal/30 hover:text-charcoal/50 text-xs transition-colors duration-200"
                data-testid="rating-skip-button"
              >
                Skip
              </button>
            </>
          ) : (
            <motion.p
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="text-charcoal/50 text-sm"
              style={{ fontFamily: "'Caveat', cursive", fontSize: '1.15rem' }}
            >
              Thanks for sharing
            </motion.p>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RatingPopup;
